import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { dashboardsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";

// DELETE removes the widget and its positioning entry; returns 204.
export const deleteWidgetV2 = async (
  namespace: string,
  dashboardId: string,
  widgetId: string,
): Promise<void> => {
  const url = dashboardsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    await axios.delete(
      `${url}/api/v2/ns/${namespace}/dashboards/${dashboardId}/widgets/${widgetId}`,
      { headers },
    );
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to delete widget. Please try again later.",
      );
    }
    throw new Error("An unexpected error occurred while deleting the widget.");
  }
};
